/* ==========================================================================
   cc-postnl-help.js
   Stapsgewijze klantenservice-flow (sections/cc-postnl-help.liquid).

   Keuzemenu -> Algemene vraag (contactformulier) of PostNL Pakketinformatie
   (4 stappen: pakkettype -> status -> gegevens -> uitkomst -> contact).

   Verzendregels (gelijk aan snippets/cc-delivery-eta.liquid): verzenden op
   werkdagen ma-vr, cutoff 12:00, weekend niet. Wachttermijn per pakkettype:
   brievenbus 5 werkdagen, standaard 3 werkdagen. "Bezorgd maar niet ontvangen":
   4 werkdagen na de bezorgdatum.

   Puur front-end: we bevragen PostNL/Shopify niet live. De ingevulde gegevens
   gaan mee als verborgen velden in de contactmail.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('cc-pnh');
  if (!root) return;

  // ------------------------------------------------------------------
  // Datum-helpers (lokale tijd; werkdagen = ma t/m vr)
  // ------------------------------------------------------------------
  function startOfDay(d) { var r = new Date(d); r.setHours(0, 0, 0, 0); return r; }
  function addDays(d, n) { var r = new Date(d); r.setDate(r.getDate() + n); return r; }
  function isWorkingDay(d) { var g = d.getDay(); return g >= 1 && g <= 5; }
  function nextWorkingDay(d) { var r = addDays(d, 1); while (!isWorkingDay(r)) r = addDays(r, 1); return r; }
  function addWorkingDays(d, n) {
    var r = new Date(d), added = 0;
    while (added < n) { r = addDays(r, 1); if (isWorkingDay(r)) added++; }
    return r;
  }
  // Eerstvolgende bezorgdag ná d. Brievenbus: di-za. Standaard: ma-za.
  function nextDeliveryDay(d, type) {
    var r = addDays(d, 1);
    while (true) {
      var g = r.getDay();
      if (type === 'brievenbus') { if (g >= 2 && g <= 6) break; }
      else { if (g >= 1 && g <= 6) break; }
      r = addDays(r, 1);
    }
    return r;
  }
  // Rol een datum vooruit naar een échte bezorgdag (laat 'm staan als het al er
  // een is). Voorkomt "contact vanaf zondag/maandag" bij brievenbuspost.
  function rollToDeliveryDay(d, type) {
    var r = new Date(d);
    while (true) {
      var g = r.getDay();
      if (type === 'brievenbus') { if (g >= 2 && g <= 6) break; }
      else { if (g >= 1 && g <= 6) break; }
      r = addDays(r, 1);
    }
    return r;
  }
  // Tel n bezorgdagen op bij een datum.
  function addDeliveryDays(d, n, type) {
    var r = d;
    for (var i = 0; i < n; i++) r = nextDeliveryDay(r, type);
    return r;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function toISODate(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }
  function parseDateInput(val) { var p = val.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }

  // Verzenddatum afleiden uit een besteltijdstip volgens onze verzendregels.
  function shipDateFromDateTime(dt) {
    var day = dt.getDay();
    if (day === 0 || day === 6) return startOfDay(nextWorkingDay(dt)); // weekend -> maandag
    if (dt.getHours() < 12) return startOfDay(dt);                     // werkdag < 12:00 -> zelfde dag
    return startOfDay(nextWorkingDay(dt));                             // werkdag >= 12:00 -> volgende werkdag
  }

  // ------------------------------------------------------------------
  // DOM-referenties
  // ------------------------------------------------------------------
  var loggedIn = root.dataset.loggedIn === 'true';

  var panels = {};
  root.querySelectorAll('[data-panel]').forEach(function (p) { panels[p.dataset.panel] = p; });

  var els = {
    infoBrievenbus: root.querySelector('.cc-pnh-info-brievenbus'),
    infoStandaard: root.querySelector('.cc-pnh-info-standaard'),

    subBezorgd: root.querySelector('.cc-pnh-sub-bezorgd'),
    subOnderweg: root.querySelector('.cc-pnh-sub-onderweg'),
    deliveredDate: root.querySelector('#cc-pnh-delivered-date'),

    orderPicker: root.querySelector('.cc-pnh-order-picker'),
    orderSelect: root.querySelector('#cc-pnh-order-select'),
    orderSummary: root.querySelector('.cc-pnh-order-summary'),
    manualToggle: root.querySelector('.cc-pnh-manual-toggle'),
    manualBlock: root.querySelector('.cc-pnh-manual'),

    ordernr: root.querySelector('#cc-pnh-ordernr'),
    orderdate: root.querySelector('#cc-pnh-orderdate'),
    ordertimeField: root.querySelector('.cc-pnh-ordertime'),

    outcome: root.querySelector('.cc-pnh-outcome'),
    toContact: root.querySelector('.cc-pnh-to-contact'),

    contactIntro: root.querySelector('.cc-pnh-contact-intro'),
    formFields: root.querySelector('.cc-pnh-form-fields'),
    hidden: root.querySelectorAll('[data-cc-hidden]')
  };

  var orders = [];
  try {
    var blob = document.getElementById('cc-pnh-orders');
    if (blob) orders = JSON.parse(blob.textContent || '[]');
  } catch (e) { orders = []; }

  var state = {
    branch: null,          // 'postnl' | 'algemeen'
    type: null,            // 'brievenbus' | 'standaard'
    status: null,          // 'onderweg' | 'bezorgd'
    manualMode: false,
    ordersPopulated: false,
    current: null,
    history: []
  };
  var lastCompute = { shipDate: null, contactFrom: null };

  // ------------------------------------------------------------------
  // Stap-navigatie
  // ------------------------------------------------------------------
  function showPanel(id) {
    Object.keys(panels).forEach(function (k) { panels[k].hidden = (k !== id); });
    state.current = id;
    onEnter(id);
  }
  function goTo(id) {
    if (state.current) state.history.push(state.current);
    showPanel(id);
    scrollToTop();
  }
  function goBack() {
    var prev = state.history.pop();
    if (prev) { showPanel(prev); scrollToTop(); }
  }
  function scrollToTop() {
    try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { root.scrollIntoView(); }
  }

  function onEnter(id) {
    if (id === 'pnl-status') {
      els.infoBrievenbus.hidden = state.type !== 'brievenbus';
      els.infoStandaard.hidden = state.type !== 'standaard';
    } else if (id === 'pnl-details') {
      setupDetails();
    } else if (id === 'pnl-outcome') {
      recomputeOutcome();
    } else if (id === 'contact') {
      fillHiddenFields();
      setContactIntro();
    }
  }

  // ------------------------------------------------------------------
  // Stap 3 — gegevens
  // ------------------------------------------------------------------
  function setupDetails() {
    var bezorgd = state.status === 'bezorgd';
    els.subBezorgd.hidden = !bezorgd;
    els.subOnderweg.hidden = bezorgd;
    if (bezorgd) return;

    // Onderweg: order-kiezer (ingelogd) of handmatig.
    if (loggedIn && orders.length > 0) {
      populateOrders();
      els.orderPicker.hidden = false;
      els.manualBlock.hidden = !state.manualMode;
    } else {
      if (els.orderPicker) els.orderPicker.hidden = true;
      els.manualBlock.hidden = false;
      state.manualMode = true;
    }
    updateOrdertimeVisibility();
  }

  function populateOrders() {
    if (state.ordersPopulated || !els.orderSelect) return;
    orders.forEach(function (o, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = o.created_at ? (o.name + ' — besteld ' + fmtDate(new Date(o.created_at))) : o.name;
      els.orderSelect.appendChild(opt);
    });
    state.ordersPopulated = true;
  }

  function getSelectedOrder() {
    if (state.manualMode || !els.orderSelect) return null;
    var idx = els.orderSelect.value;
    if (idx === '') return null;
    return orders[+idx] || null;
  }

  function getOrdertime() {
    var c = root.querySelector('input[name="cc-pnh-ordertime"]:checked');
    return c ? c.value : null;
  }

  function updateOrdertimeVisibility() {
    if (!els.ordertimeField || !els.orderdate) return;
    if (!els.orderdate.value) { els.ordertimeField.hidden = false; return; }
    var d = parseDateInput(els.orderdate.value);
    els.ordertimeField.hidden = (d.getDay() === 0 || d.getDay() === 6);
  }

  // Klantvriendelijke status i.p.v. Shopify's ruwe label ("Openstaand"/"Afgehandeld").
  function friendlyStatus(order) {
    if (order.fulfillment_status === 'fulfilled' || order.ship_date) return 'Verzonden';
    if (order.fulfillment_status === 'partial') return 'Deels verzonden';
    return 'Wordt verwerkt';
  }

  function renderOrderSummary() {
    var order = getSelectedOrder();
    if (!order) { els.orderSummary.hidden = true; return; }
    var html = '<div><strong>' + escapeHtml(order.name) + '</strong></div>';
    if (order.created_at) html += '<div>Besteld op ' + escapeHtml(fmtDate(new Date(order.created_at))) + '</div>';
    html += '<div>Status: ' + escapeHtml(friendlyStatus(order)) + '</div>';
    if (order.ship_date) html += '<div>Verzonden op ' + escapeHtml(fmtDate(new Date(order.ship_date))) + '</div>';
    if (order.tracking_url) {
      html += '<div><a href="' + escapeAttr(order.tracking_url) + '" target="_blank" rel="noopener">Bekijk je Track &amp; Trace bij PostNL &rarr;</a></div>';
    } else {
      html += '<div class="cc-pnh-hint">Nog geen Track &amp; Trace-code — het pakket is waarschijnlijk nog niet door PostNL gescand.</div>';
    }
    els.orderSummary.innerHTML = html;
    els.orderSummary.hidden = false;
  }

  // Validatie vóór we de uitkomst tonen.
  function validateDetails() {
    clearErrors();
    if (state.status === 'bezorgd') {
      if (!els.deliveredDate.value) { showError('delivered'); return false; }
      return true;
    }
    // Onderweg
    if (getSelectedOrder()) return true;
    // Ingelogd met order-kiezer, maar niets gekozen én niet handmatig:
    if (loggedIn && orders.length > 0 && !state.manualMode) { showError('order'); return false; }
    var ok = true;
    if (!/^5\d{5}$/.test(els.ordernr.value)) { showError('ordernr'); ok = false; }
    if (!els.orderdate.value) {
      showError('orderdate'); ok = false;
    } else {
      var od = parseDateInput(els.orderdate.value);
      var weekend = od.getDay() === 0 || od.getDay() === 6;
      if (!weekend && !getOrdertime()) { showError('ordertime'); ok = false; }
    }
    return ok;
  }

  function showError(key) {
    var el = root.querySelector('[data-error-for="' + key + '"]');
    if (el) el.hidden = false;
  }
  function clearErrors() {
    root.querySelectorAll('[data-error-for]').forEach(function (e) { e.hidden = true; });
  }

  // ------------------------------------------------------------------
  // Stap 4 — uitkomst berekenen
  // ------------------------------------------------------------------
  function recomputeOutcome() {
    var data = state.status === 'bezorgd' ? computeDelivered() : computeOnderweg();
    renderOutcome(data);
  }

  // "Bezorgd, niet ontvangen" -> 4 werkdagen na de bezorgdatum (datum is verplicht).
  function computeDelivered() {
    var basis = startOfDay(parseDateInput(els.deliveredDate.value));
    var contactFrom = addWorkingDays(basis, 4);
    var withinWindow = startOfDay(new Date()) < contactFrom;
    lastCompute.shipDate = null;
    lastCompute.contactFrom = contactFrom;

    if (withinWindow) {
      return {
        withinWindow: true,
        title: 'Nog heel even geduld',
        body: 'Een pakket dat op “bezorgd” staat maar nog niet is aangekomen, komt meestal binnen ' +
              'een paar werkdagen alsnog boven water. Is het er op <strong>' + fmtDate(contactFrom) +
              '</strong> nog steeds niet? Neem dan contact met ons op.',
        timeline: null
      };
    }
    return {
      withinWindow: false,
      title: 'Neem gerust contact op',
      body: 'Het pakket staat inmiddels langer dan een paar werkdagen op “bezorgd” zonder dat je het ' +
            'hebt ontvangen. Neem contact op, dan zoeken we het samen met PostNL uit.',
      timeline: null
    };
  }

  // "Nog onderweg" -> verzenddatum bepalen, dan wachttermijn per pakkettype.
  function computeOnderweg() {
    var type = state.type;
    var order = getSelectedOrder();
    var shipDate = null, shipEstimated = true;

    if (order) {
      if (order.ship_date) { shipDate = startOfDay(new Date(order.ship_date)); shipEstimated = false; }
      else if (order.created_at) { shipDate = shipDateFromDateTime(new Date(order.created_at)); }
    } else if (els.orderdate.value) {
      var od = parseDateInput(els.orderdate.value);
      var weekend = od.getDay() === 0 || od.getDay() === 6;
      var tc = getOrdertime();
      if (weekend) shipDate = shipDateFromDateTime(new Date(od.getFullYear(), od.getMonth(), od.getDate(), 10, 0, 0));
      else if (tc) { var h = tc === 'before' ? 10 : 14; shipDate = shipDateFromDateTime(new Date(od.getFullYear(), od.getMonth(), od.getDate(), h, 0, 0)); }
    }

    if (!shipDate) {
      lastCompute.shipDate = null; lastCompute.contactFrom = null;
      return { withinWindow: true, title: 'We hebben nog gegevens nodig',
               body: 'Ga terug en vul je besteldatum en besteltijd in.', timeline: null };
    }

    var threshold = type === 'brievenbus' ? 5 : 3;
    // Verwacht in huis: brievenbus 2 bezorgdagen, standaard 1 — altijd op een echte bezorgdag.
    var expectedDays = type === 'brievenbus' ? 2 : 1;
    var expected = addDeliveryDays(shipDate, expectedDays, type);
    // "Contact vanaf" op een dag dat er ook echt bezorgd wordt (bij brievenbus
    // dus niet op zondag/maandag): rol vooruit naar de eerstvolgende bezorgdag.
    var contactFrom = rollToDeliveryDay(addWorkingDays(shipDate, threshold), type);
    var withinWindow = startOfDay(new Date()) < contactFrom;
    lastCompute.shipDate = shipDate;
    lastCompute.contactFrom = contactFrom;

    var typeLabel = type === 'brievenbus' ? 'brievenbuspakket' : 'pakket';
    if (withinWindow) {
      return {
        withinWindow: true,
        title: 'Je ' + typeLabel + ' is naar verwachting nog onderweg',
        body: 'Op basis van ' + (shipEstimated ? 'onze verzendregels' : 'de verzenddatum') +
              ' verwachten we bezorging rond <strong>' + fmtDate(expected) + '</strong>. ' +
              (type === 'brievenbus' ? 'Brievenbuspost komt op dinsdag t/m zaterdag (niet op maandag). ' : '') +
              'Is het op <strong>' + fmtDate(contactFrom) + '</strong> nog niet binnen? Neem dan contact op.',
        timeline: [
          { label: shipEstimated ? 'Geschat verzonden' : 'Verzonden', value: fmtDate(shipDate) },
          { label: 'Verwacht in huis', value: 'rond ' + fmtDate(expected) },
          { label: 'Contact opnemen vanaf', value: fmtDate(contactFrom) }
        ]
      };
    }
    return {
      withinWindow: false,
      title: 'Het duurt langer dan normaal — we kijken graag mee',
      body: 'Je ' + typeLabel + ' had normaal gesproken nu bezorgd moeten zijn. Meestal komt het alsnog ' +
            'aan, maar we snappen dat je zekerheid wilt. Neem contact op, dan zoeken we het voor je uit.',
      timeline: [
        { label: shipEstimated ? 'Geschat verzonden' : 'Verzonden', value: fmtDate(shipDate) },
        { label: 'Verwacht in huis', value: 'rond ' + fmtDate(expected) },
        { label: 'Verwacht binnen vanaf', value: fmtDate(contactFrom) }
      ]
    };
  }

  function renderOutcome(data) {
    var variant = data.withinWindow ? 'cc-callout--info' : 'cc-callout--warning';
    var html = '<div class="cc-callout ' + variant + '">';
    html += '<h2 class="cc-pnh-outcome-title">' + data.title + '</h2>';
    html += '<p>' + data.body + '</p>';
    if (data.timeline) {
      html += '<ul class="cc-pnh-timeline">';
      data.timeline.forEach(function (i) {
        html += '<li><span class="cc-pnh-timeline-label">' + escapeHtml(i.label) + '</span>' +
                '<span class="cc-pnh-timeline-value">' + escapeHtml(i.value) + '</span></li>';
      });
      html += '</ul>';
    }
    html += '</div>';
    els.outcome.innerHTML = html;
    if (els.toContact) els.toContact.textContent = data.withinWindow ? 'Toch contact opnemen' : 'Contact opnemen';
  }

  // ------------------------------------------------------------------
  // Contact — verborgen velden + intro
  // ------------------------------------------------------------------
  function setContactIntro() {
    if (!els.contactIntro) return;
    els.contactIntro.textContent = state.branch === 'algemeen'
      ? 'Stel hieronder je vraag. We reageren zo snel mogelijk via je e-mailadres.'
      : 'We sturen de gegevens van je pakket alvast mee. Vul je bericht aan en verstuur.';
  }

  function fillHiddenFields() {
    var order = getSelectedOrder();
    var data = {};

    if (state.branch === 'algemeen') {
      data.onderwerp = 'Algemene vraag';
    } else {
      var t = state.type === 'brievenbus' ? 'Brievenbuspakket' : 'Standaard pakket';
      var s = state.status === 'bezorgd' ? 'staat op bezorgd, niet ontvangen' : 'nog onderweg';
      data.onderwerp = 'PostNL pakketinformatie – ' + t + ' – ' + s;
    }

    if (state.branch === 'postnl') {
      if (order) data.ordernr = order.name;
      else if (els.ordernr && els.ordernr.value) data.ordernr = '#CC' + els.ordernr.value;
      else data.ordernr = '';

      if (order && order.created_at) data.orderdate = fmtDate(new Date(order.created_at));
      else if (els.orderdate && els.orderdate.value) data.orderdate = fmtDate(parseDateInput(els.orderdate.value));
      else data.orderdate = '';

      data.type = state.type === 'brievenbus' ? 'Brievenbuspakket' : 'Standaard pakket';
      data.situatie = state.status === 'bezorgd' ? 'Staat op bezorgd, niet ontvangen' : 'Nog onderweg';
      data.shipdate = lastCompute.shipDate ? fmtDate(lastCompute.shipDate) : '';
      data.contactfrom = lastCompute.contactFrom ? fmtDate(lastCompute.contactFrom) : '';
      data.tracking = order && order.tracking_url ? order.tracking_url :
                      (order && order.tracking_number ? order.tracking_number : '');
    }

    els.hidden.forEach(function (input) {
      var key = input.dataset.ccHidden;
      input.value = data[key] != null ? data[key] : '';
    });
  }

  // ------------------------------------------------------------------
  // Events
  // ------------------------------------------------------------------
  function bindEvents() {
    // Gedelegeerde navigatie via data-attributen.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-goto],[data-back],[data-action],[data-branch],[data-type],[data-status]');
      if (!btn || !root.contains(btn)) return;

      if (btn.dataset.branch) state.branch = btn.dataset.branch;
      if (btn.dataset.type) state.type = btn.dataset.type;
      if (btn.dataset.status) state.status = btn.dataset.status;

      if (btn.hasAttribute('data-back')) { goBack(); return; }
      if (btn.dataset.action === 'compute') { if (validateDetails()) goTo('pnl-outcome'); return; }
      if (btn.dataset.goto) { goTo(btn.dataset.goto); return; }
    });

    if (els.manualToggle) els.manualToggle.addEventListener('click', function () {
      state.manualMode = true;
      els.manualBlock.hidden = false;
      els.orderSummary.hidden = true;
      if (els.orderSelect) els.orderSelect.value = '';
    });
    if (els.orderSelect) els.orderSelect.addEventListener('change', function () {
      state.manualMode = false;
      renderOrderSummary();
    });
    if (els.ordernr) els.ordernr.addEventListener('input', function () {
      els.ordernr.value = els.ordernr.value.replace(/\D/g, '').slice(0, 6);
      clearErrors();
    });
    if (els.orderdate) els.orderdate.addEventListener('change', function () {
      updateOrdertimeVisibility(); clearErrors();
    });
    root.querySelectorAll('input[name="cc-pnh-ordertime"]').forEach(function (r) {
      r.addEventListener('change', clearErrors);
    });
    if (els.deliveredDate) els.deliveredDate.addEventListener('change', clearErrors);

    // Native form-verzending (betrouwbaar: precies één bericht). Vlak vóór het
    // verzenden vullen we de verborgen context-velden. Shopify verwerkt het en
    // stuurt terug naar deze pagina met ?contact_posted=true — dan tonen we de
    // bevestiging (zie init).
    var form = panels.contact ? panels.contact.querySelector('form') : null;
    if (form) form.addEventListener('submit', function () { fillHiddenFields(); });
  }

  // Toast rechtsboven (hangt aan <body>).
  function showToast(msg, isError) {
    var t = document.createElement('div');
    t.className = 'cc-pnh-toast' + (isError ? ' cc-pnh-toast--error' : '');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 5000);
  }

  // ------------------------------------------------------------------
  // Utilities
  // ------------------------------------------------------------------
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return String(s).replace(/"/g, '&quot;'); }

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  function init() {
    var todayISO = toISODate(new Date());
    if (els.orderdate) els.orderdate.max = todayISO;
    if (els.deliveredDate) els.deliveredDate.max = todayISO;

    bindEvents();

    // Na een succesvolle verzending komt Shopify terug met de succes-status:
    // toon direct de bevestiging (geen wizard) + een toast rechtsboven.
    if (root.querySelector('.cc-pnh-success')) {
      if (els.formFields) els.formFields.hidden = true;
      showPanel('contact');
      showToast('Je bericht is verzonden! We nemen zo snel mogelijk contact met je op via je e-mailadres.');
      return;
    }

    showPanel('menu');
  }

  init();
})();
